import React from 'react';
import { BaseText } from './BaseText';
import { defineFontSettings } from './fontSettings';

export const Body2 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: '16px', lineHeight: '24px' },
    { fontSize: '20px', lineHeight: '28px' }
  );
  return (
    <BaseText fontSettings={fontSettings} {...props}>
      {children}
    </BaseText>
  );
};
